export const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');

export const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  } catch { return '-'; }
};

export const gbErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  return 'Falha na operação.';
};

export const MAPS = { pumpkin: 'Abóboras', graveyard: 'Cemitério', castle: 'Castelo' };

export const FLAG_LABEL = {
  fast_match: 'Partida muito rápida',
  long_match: 'Partida muito longa',
  too_many_shots: 'Tiros acima do normal',
  daily_cap: 'Bateu o teto diário',
  abandoned: 'Abandonou a partida',
  impossible_damage: 'Dano incompatível',
};

export const AUDIT_LABEL = {
  season_created: 'Temporada criada',
  season_activated: 'Temporada ativada',
  season_closed: 'Temporada encerrada',
  config_changed: 'Configuração alterada',
  diamonds_adjusted: 'Diamantes ajustados',
  player_blocked: 'Jogador bloqueado',
  player_unblocked: 'Jogador desbloqueado',
  suspicion_cleared: 'Suspeita zerada',
};
